import clsx from "clsx";
import { useEffect, useState } from "react";

import { clockTime } from "~/utils/time";

export const Timer: React.FC<{
  endsAt: number;
  onEnd: () => void;
}> = ({ endsAt, onEnd }) => {
  const [timeLeft, setTimeLeft] = useState(endsAt - Date.now());

  useEffect(() => {
    const interval = setInterval(() => {
      const now = Date.now();

      if (now >= endsAt) {
        clearInterval(interval);
        setTimeLeft(0);
        onEnd();
        return;
      }

      setTimeLeft(endsAt - now);
    }, 100);
    return () => {
      clearInterval(interval);
    };
  }, [endsAt, onEnd]);

  const seconds = Math.round(timeLeft / 1000);

  return (
    <div
      className={clsx(
        "text-3xl tabular-nums heading md:text-4xl",
        seconds <= 5 && "text-error",
      )}
    >
      {clockTime(seconds)}
    </div>
  );
};
